import { FieldType, BaseRateRequest } from '@pmp/api';
import { CrudMode, FormItem, SelectsOptions, RenderFormItem } from '@ohpen/enso-ui';

export const getBaseRatesFormSchema = (
  selectsOptions: SelectsOptions,
  renderAlert: RenderFormItem<BaseRateRequest>,
  mode?: CrudMode | null,
): FormItem[] => [
  {
    renderFormItem: renderAlert,
  },
  {
    title: 'pmp.baseRates.labels.baseRateId',
    dataIndex: 'code',
    formItemProps: {
      required: mode === CrudMode.CREATE,
    },
    fieldProps: {
      disabled: mode !== CrudMode.CREATE,
    },
  },
  {
    title: 'pmp.baseRates.labels.baseRateName',
    dataIndex: 'name',
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
  {
    title: 'pmp.baseRates.labels.variabilityType',
    dataIndex: 'variabilityType',
    valueType: 'select',
    formItemProps: {
      required: true,
      hidden: mode === CrudMode.EDIT,
    },
    fieldProps: {
      options: selectsOptions[FieldType.VARIABILITY_TYPE],
      disabled: mode !== CrudMode.CREATE,
    },
  },
  {
    title: 'pmp.baseRates.labels.rate',
    dataIndex: 'amount',
    valueType: 'percent',
    dependencies: ['variabilityType'],
    formItemProps: form => ({
      required: true,
      hidden: mode === CrudMode.EDIT,
    }),
    fieldProps: {
      precision: 4,
      disabled: mode !== CrudMode.CREATE,
    },
  },
  {
    title: 'pmp.baseRates.labels.startDate',
    dataIndex: 'startDate',
    valueType: 'date',
    dependencies: ['variabilityType'],
    formItemProps: form => ({
      required: true,
      hidden: mode === CrudMode.EDIT,
    }),
    fieldProps: {
      disabled: mode !== CrudMode.CREATE,
    },
  },
  {
    title: 'pmp.baseRates.labels.endDate',
    dataIndex: 'endDate',
    valueType: 'date',
    formItemProps: {
      hidden: mode !== CrudMode.VIEW,
    },
    fieldProps: {
      disabled: true,
    },
  },
];

export const getInterestRatesFormSchema = (mode?: CrudMode | null): FormItem[] => [
  {
    title: 'pmp.baseRates.labels.rate',
    dataIndex: 'amount',
    valueType: 'percent',
    formItemProps: {
      required: true,
    },
    fieldProps: {
      precision: 4,
    },
  },
  {
    title: 'pmp.baseRates.labels.startDate',
    dataIndex: 'startDate',
    valueType: 'date',
    formItemProps: {
      required: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.index',
    dataIndex: 'index',
    formItemProps: {
      hidden: mode === CrudMode.CREATE,
    },
    fieldProps: {
      disabled: true,
    },
  },
];
